<template lang="pug">
.form-config.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.config" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.config }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="config" title="Nombre de La Configuración")

      .input-container.arrow
        select.select(v-model="dataForm.value" autocomplete="ño" required)
          option(value="epayco") Epayco
          option(value="payu") Pay U
          option(value="wompi") Wompi
        label.label(:class="{ show: dataForm.value }") Valor

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteConfig")
</template>

<script>
import mForm from '@/mixins/form'
import mDB from '@/mixins/db'
import gqlConfig from '@/graphql/config'
import shDeleteButton from '@/components/elements/DeleteButton'
import shProperty from '@/components/elements/Property'

export default {
  name: 'FormConfig',

  mixins: [mForm, mDB],

  components: { shDeleteButton, shProperty },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        config: '',
        value: ''
      },
      resolver: 'config',
      key: 'config',
      gql: gqlConfig
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    initDiscounts () {
      this.dataForm.value = 0
      this.dataForm.percent = 0
    },

    sendForm () {
      if (!this.fillData) {
        this.newConfig()
      } else {
        this.updateConfig()
      }
    },

    newConfig () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateConfig () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteConfig () {
      this.deleteData(this.gql, this.resolver, this.key)
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-config
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/config/Form.vue